import customAxios from "./axiosConfig";

const DocumentUploadService = {
  bulkUpload(data) {
    if (data.files) {
      // const files_data = []
      const file_promises = []

      data.files.forEach(file => {
        const formData = new FormData();
        formData.append('type_of_content', 'Correction');
        formData.append('object_id', data.attached_to.id);
        formData.append('valid_from', new Date().format('Y-m-d'));
        formData.append('title', file.name);
        formData.append('description', data.description);
        formData.append('company_profile', data.company_profile);
        formData.append('file', file);
        formData.append('file_size', file.size);

        // files_data.push(formData)
        file_promises.push(this.uploadFile(formData))
      })
      // console.log('files_data ->', files_data)
      // return this.uploadFilesSequential(files_data)

      return Promise.all(file_promises)
    } 
  },
  async uploadFilesSequential(files_data) {
    let index = 0
    const sleep = 1000
    console.log('--------------- start loop')
    for (const file of files_data) {
      index++
      console.log(' -> iteration ' + index + ' of ' + files_data.length)
      await this.uploadFile(file)
      console.log('    uploadFile finished, sleep ' + sleep + 'ms')
      // await this.timer(sleep)
      console.log('    end iteration')
    }
    console.log('--------------- end loop')
  },
  uploadFile (data) {
    const api_url = window.Urls['document-list']();
    return customAxios.post(api_url, data);
  },
  timer (ms) {
    return new Promise(res => setTimeout(res, ms))
  }
}

export default DocumentUploadService;
